import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    root: {},
    wrapper: {
      marginTop: theme.spacing(1),
      padding: theme.spacing(2),
      backgroundColor: COLORS.gray.white,
      borderRadius: theme.shape.borderRadius,
      border: theme.shape.borderGray70,
    },
    optional: {
      color: COLORS.gray.gray50,
      fontWeight: theme.typography.fontWeightRegular,
    },
    field: {
      '& + &': {
        marginTop: theme.spacing(2),
      },
    },
    label: {
      fontWeight: theme.typography.regular14,
    },
  }),
  { name: 'FormContext' }
);
